import { useEffect, useMemo, useState } from "react";

/**
 * "Bảng tính sống" ở đầu /mau: một bảng Excel thu nhỏ tự đổi ô giả định
 * "Tăng trưởng mỗi tháng" và TÍNH LẠI THẬT các ô kết quả cùng biểu đồ tiền mặt
 * 18 tháng (mô hình đơn giản, số ví dụ). Cho thấy giá trị của mẫu: ô nhập tách
 * khỏi ô công thức, đổi một giả định là cả bảng chạy lại.
 *
 * Dưới đáy là các thẻ sheet = nhóm mẫu; chạm để lọc danh sách (onChon).
 * HTML prerender là kịch bản đầu, đọc được khi chưa có JavaScript.
 */
const TIEN_DAU = 3000; // triệu
const DT_DAU = 54; // doanh thu tháng 1, triệu
const CHI_CO_DINH = 260; // triệu/tháng
const BIEN_PHI = 0.2; // 20% doanh thu
const KICH_BAN = [0.15, 0.08, 0.22];

function tinh(g) {
  let tien = TIEN_DAU, hoaVon = null, het = null, thap = TIEN_DAU;
  const duong = [];
  for (let t = 1; t <= 18; t++) {
    const dt = DT_DAU * (1 + g) ** (t - 1);
    const lai = dt - CHI_CO_DINH - BIEN_PHI * dt;
    tien += lai;
    if (hoaVon == null && lai >= 0) hoaVon = t;
    if (het == null && tien < 0) het = t;
    thap = Math.min(thap, tien);
    duong.push(tien);
  }
  return { hoaVon, het, thap, duong };
}
const ty = (tr) => `${(tr / 1000).toFixed(1).replace(".", ",")} tỷ`;

export default function MauSong({ nhom, dangChon, onChon }) {
  const [k, setK] = useState(0);
  const [nhay, setNhay] = useState(0);
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    const id = setInterval(() => {
      if (document.hidden) return;
      setK((x) => (x + 1) % KICH_BAN.length);
      setNhay((n) => n + 1);
    }, 3400);
    return () => clearInterval(id);
  }, []);

  const g = KICH_BAN[k];
  const kq = useMemo(() => tinh(g), [g]);
  // Biểu đồ: trục y từ min(0, thấp nhất) tới tiền đầu kỳ.
  const W = 300, H = 74, lo = Math.min(-400, kq.thap), hi = TIEN_DAU;
  const y = (v) => H - ((v - lo) / (hi - lo)) * H;
  const diem = kq.duong.map((v, i) => `${(i / 17) * W},${y(v).toFixed(1)}`).join(" ");

  return (
    <div className="ms">
      <div className="ms-fx" aria-hidden="true">
        <span className="ms-fx-o">B6</span><span className="ms-fx-f">fx</span>
        <code>=MATCH(TRUE, LoiNhuan&gt;=0, 0)</code>
      </div>
      <table className="ms-bang">
        <caption className="sr-only">Ví dụ: đổi tăng trưởng, bảng tự tính lại tháng hòa vốn và tiền mặt thấp nhất</caption>
        <thead aria-hidden="true"><tr><th /><th>A</th><th>B</th></tr></thead>
        <tbody>
          <tr className="ms-muc"><th>1</th><td colSpan={2}>Giả định (ô bạn nhập)</td></tr>
          <tr><th>2</th><td>Doanh thu tháng đầu</td><td className="ms-nhap">{DT_DAU} triệu</td></tr>
          <tr><th>3</th><td>Tăng trưởng mỗi tháng</td><td className="ms-nhap ms-doi" key={`g${nhay}`}>{Math.round(g * 100)}%</td></tr>
          <tr><th>4</th><td>Chi phí cố định / tháng</td><td className="ms-nhap">{CHI_CO_DINH} triệu</td></tr>
          <tr className="ms-muc"><th>5</th><td colSpan={2}>Kết quả (công thức tự tính)</td></tr>
          <tr><th>6</th><td>Tháng hòa vốn</td>
            <td className="ms-cong-thuc ms-tinh" key={`h${nhay}`}>{kq.hoaVon ? `Tháng ${kq.hoaVon}` : "Chưa trong 18 tháng"}</td></tr>
          <tr><th>7</th><td>Tiền mặt thấp nhất</td>
            <td className={`ms-cong-thuc ms-tinh${kq.het ? " am" : ""}`} key={`t${nhay}`}>{kq.het ? `Hết tiền tháng ${kq.het}` : ty(kq.thap)}</td></tr>
        </tbody>
      </table>
      <div className="ms-bieu-do" aria-hidden="true">
        <span className="ms-bd-nhan">Tiền mặt 18 tháng</span>
        <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
          <line x1="0" x2={W} y1={y(0)} y2={y(0)} className="ms-bd-0" />
          <polyline points={diem} className={`ms-bd-duong${kq.het ? " am" : ""}`} />
        </svg>
      </div>
      <div className="ms-tab" role="group" aria-label="Lọc mẫu theo việc cần làm">
        {nhom.map((n) => (
          <button key={n.slug} type="button" className={dangChon === n.slug ? "dang" : ""} aria-pressed={dangChon === n.slug}
            onClick={() => onChon(dangChon === n.slug ? "" : n.slug)}>
            {n.ten} <b>{n.so}</b>
          </button>
        ))}
      </div>
    </div>
  );
}
